import { DataArray, IDataArray } from "./../../shared/index";
import { Company, Equipment, Project } from "./../index";

export class Minesite implements IDataArray {
  public Id: number;
  public Name = "";
  public Active: boolean;
  public LastModified: Date;
  public Live: boolean;
  public Is_Live: boolean;
  public Minesite_ID: number;
  public Is_Published: boolean;
  public Status: number;
  public Is_Changed: boolean;
  public Associated_ID: number;
  public Companies: DataArray<Company> = new DataArray<Company>(1);
  public Equipment: DataArray<Equipment> = new DataArray<Equipment>(1);
  constructor() {
    this.Is_Live = true;
  }
  public GetById(): number {
    return this.Id != undefined ? this.Id : this.Minesite_ID;
  }
}
